import * as React from "react";
import { singleton } from "logic/singleton";
const ExpandedSectionsContext = React.createContext(void 0);
export default singleton("contexts.ExpandedSectionsContext", () => ExpandedSectionsContext);
